export default {
  api: {
    ps: 'https://www.x-bull.com/v2',
    uc: 'https://ucapi.10niu.cn',
    admin: 'https://adminapi.10niu.cn',
    forum: 'https://forumapi.10niu.cn',
    pos: 'https://posapi.10niu.cn',
    face: 'https://faceapi.10niu.cn',
    attendance: 'https://attendanceapi.10niu.cn',
    schoolstruct: 'https://schoolstructapi.10niu.cn',
    cloudEducation: 'https://heeducation.10niu.cn',
    workneapi: 'https://xbullworkoneapi.10niu.cn',
    znx: 'https://zhaonaxapi.10niu.cn',
    oss: 'https://ossapi.10niu.cn',
    ai: 'https://aiapi.10niu.cn',
    device: 'https://deviceapi.10niu.cn',
    schoolDismissal: 'https://school-dismissal-api.10niu.cn'
  }, // 接口
  headers: {
    Accept: 'application/json, text/plain, */*',
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    'x-ca-stage': 'RELEASE'
  }, // 网关默认的请求头
  cdn: {}, // cdn配置
  gateway: {
    key: '25486406',
    secret: 'aba58659ffcde1fd6c6d4580f83ba1f1'
  }, // 网关配置
  log: false, // 是否开启日志记录
  logger: {
    error_log: {
      host: 'cn-shenzhen.log.aliyuncs.com',
      project: 'school',
      store: 'admin_frontend_err_log'
    } // 错误日志配置
  }, // 日志配置
  userInfo: {
    merchantRole: 5965 // 商户角色的roleId
  },
  url: '//www.x-bull.com/v2/',
  zhaonaxueHostName: 'p.zhaonax.com', // 找哪学域名
  zhaonaxueUrl: 'https://pi.zhaonax.com/v2/',
  // dlsIds: [19672, 19673] // 代理商id列表，只对这些人开放
  routeUrl: '/v2',
  scanToSign: 'https://www.x-bull.com/PrimarySchoolWeChat/dist/index.html#' // 扫码进入小程序配置
};
